import Cashback from './Cashback'

export default Cashback
